import { InvoiceTypeEnum } from "@src/components/modules/invoices/Create/store";
import { dateTime } from "@src/utils/formatters";
import type React from "react";
import type { FC } from "react";
import { useStore } from "../../../store";
import type { ColumnProps } from ".";
import { EditDateWrapper } from "./edit-date-wrapper";

export const IssueDate: FC<React.PropsWithChildren<ColumnProps>> = ({
  row,
}) => {
  const store = useStore();
  return (
    <EditDateWrapper
      dataComponentName="issue-date-edit-date-trigger"
      isDisabled={!row.issue_date}
      row={row}
      invoiceType={InvoiceTypeEnum.Proforma}
      onUpdate={store.proformaInvoicesRefetch}
      modalStore={store.changeDatesModalStore}
    >
      {row.issue_date ? dateTime.format(new Date(row.issue_date)) : undefined}
    </EditDateWrapper>
  );
};
